<template>
  <div :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
              <a-row :gutter="24">
                <a-col :md="6" :sm="8">
                  <a-form-item :label="'Business Disbursement No.'">
                    <a-input
                        :placeholder="$t('enter') + ' Business Disbursement No.'"
                        v-model="queryParam.payInId"/>
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="8">
                  <a-form-item :label="'Collection Account'">
                    <a-input
                      :placeholder="$t('enter') + ' Collection Account'"
                      v-model="queryParam.toMsisdn"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="8">
                  <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                    <a-button type="primary" @click="searchQuery" icon="search">{{ $t('search') }}</a-button>
                    <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('reset') }}</a-button>
                  </span>
                </a-col>
              </a-row>
            </a-form>
      <a-table
        ref="table"
        rowKey="id"
        size="middle"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="false"
        :loading="loading"
        :scroll="{x:1000}"
        bordered
        @change="handleTableChange">
        <span slot="action" slot-scope="text, record">
            <a  v-if='record.status == "03"' @click="loanFailedDeal(record)" style="margin-left: 8px">Process as Disbursement Failed</a>
          <a  v-if='record.status == "03"' @click="supplementaryRecording(record)" style="margin-left: 8px">Supplement Disbursement No.</a>
          <a  v-if='record.status == "03"' @click="loanSuccessDeal(record)" style="margin-left: 8px">Process as Disbursement Successful</a>
          <a  v-if='record.status == "03"' @click="cancelDeal(record)" style="margin-left: 8px">Process as Order Cancelled</a>
        </span>
      </a-table>
      <div style="margin-top: 15px; text-align: right;">
          <v-pagination
              v-if="total"
              :page-num="form.pageNum"
              :page-size="form.pageSize"
              :total="total"
              @change="handleTableChange" />
      </div>
    </div>
    <v-modal
        v-model="visible"
        :title="$t(I18N_KEY + 'orderDetail')">
        <div style="padding: 20px;">
            <order-detail v-if="visible" :orderId="orderId" :custInfoId="custInfoId"/>
        </div>
    </v-modal>

    <a-modal v-model="visibleO" title="Payment Chain Answer" @ok="handleOk">
       <p>{{ ModalText }}</p>
    </a-modal>
  </div>
</template>

<script>
import { filterObj } from '@/utils/util'
import {
  getPlatformLoanOrderList,
  paymentsLink,
  reductionLateFee,
  repayOfflineAll,
  extendOffline,
  repayStatusCheck,
  getPkPayoutErrorList, loanFailedDeal, accountCancellation, supplementaryRecording, loanSuccessDeal
} from
    '@/webpublicapi/order'
import Dict from '../modules/Dict';
import DictSelect from '../modules/DictSelect';
import moment from 'moment'
import vModal from '../modules/Modal';
import OrderDetail from '../order/OrderDetail';
import { getApplist} from '@/webpublicapi/order'
import md5 from 'md5'
const I18N_KEY = 'order.';

export default {
  name: 'LoanOrderlist',
  components: {
    Dict,
    DictSelect,
    vModal,
    OrderDetail,
  },
  data () {
    return {
      appList:[],
      I18N_KEY,
      toggleSearchStatus:false,
      visible: false,
      visibleO: false,
      ModalText: '',
      orderId: undefined,
      custInfoId: undefined,
      // Pagination params
      dataSource: [],
      form: {
        pageNum: 1,
        pageSize: 30,
      },
      total: 0,
      // Query conditions
      queryParam: {
        "orderNo":"",
        "orderId":undefined,
        "mobileNo":"",
        "aadhaarName":"",
        "applyDate":undefined,
        "paymentDate":undefined,
        "settleDate":undefined,
        "endDate":undefined,
        'appSsids': '',
        // "email":""
      },
      loading: false,
      isorter: {
        column: 'createTime',
        order: 'desc'
      },
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      }
    }
  },
  computed: {
    columns () {
      return [
        {
          title: 'Order No.',
          align: 'left',
          width: '100px',
          dataIndex: 'orderInfoId'
        },
        {
          title: 'CustomerNo.',
          align: 'left',
          width: '100px',
          dataIndex: 'custInfoId'
        },
        {
          title: 'Business Disbursement No.',
          align: 'left',
          width: '200px',
          dataIndex: 'payInId'
        },
        {
          title: 'Payee',
          align: 'left',
          width: '150px',
          dataIndex: 'toMsisdn'
        },
        {
          title: 'AbnormalCode',
          align: 'left',
          width: '200px',
          dataIndex: 'errorCode'
        },
        {
          title: 'AbnormalInfo',
          align: 'left',
          width: '200px',
          dataIndex: 'errorMessage'
        },
        // {
        //   title: 'Balance after previous transaction success',
        //   align: 'left',
        //   width: '200px',
        //   dataIndex: 'beforeBalanceAmount'
        // },
        // {
        //   title: 'Balance after next transaction success',
        //   align: 'left',
        //   width: '200px',
        //   dataIndex: 'afterBalanceAmount'
        // },
        // {
        //   title: 'Next loan disbursement amount',
        //   align: 'left',
        //   width: '200px',
        //   dataIndex: 'afterPayoutAmount'
        // },
        // {
        //   title: 'Balance difference after previous/next transaction success',
        //   align: 'left',
        //   width: '200px',
        //   dataIndex: 'beforeAfterBalanceAmount'
        // },
        {
          title: 'Channel',
          align: 'left',
          width: '200px',
          dataIndex: 'channel'
        },
        {
          title: 'Processing Status',
          align: 'left',
          width: '200px',
          dataIndex: 'status'
        },
        {
          title: 'Date',
          align: 'left',
          width: '200px',
          dataIndex: 'updateTime'
        }
          ,
        {
          title: this.$t('action'),
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 300,
          scopedSlots: { customRender: 'action' }
        }
      ]
    },
  },
  created () {
    // this.loadData(1)
    // getApplist().then(res => {
    //   this.appList = res.data || [];
    // })
  },
  methods: {

    handleToggleSearch(){
      this.toggleSearchStatus = !this.toggleSearchStatus;
    },
    searchQuery () {
      this.loadData(1)
    },
    loadData (arg) {
      // Load data If params passed1Then load first page content
      if (arg === 1) {
        this.form.pageNum = 1
      }

      this.loading = true
      var params = this.getQueryParams()// Query conditions
      getPkPayoutErrorList(Object.assign({}, params)).then((res)=>{
        if(res.code===1000){
          this.total = res.data.total
          this.dataSource = res.data.rows
        }else{
          this.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
            this.loading = false;
            this.$message.error(e.message);
      })
    },
    transformTime (time) {
      return moment(time).format('YYYY-MM-DD')
    },
    transformStringToLow (str) {
        return str && str.toLocaleLowerCase();
    },
    getQueryParams () {
      const data = {
          ...this.queryParam,
      }
      var param = Object.assign({}, data)
      param.pageNum = this.form.pageNum
      param.pageSize = this.form.pageSize
      return filterObj(param)
    },
    handleTableChange (pageNum, pageSize) {
        this.form.pageNum = pageNum;
        this.form.pageSize = pageSize;
        this.loadData();
    },
    // Reset dictionary type search box content
    searchReset () {
      var that = this
      that.queryParam.orderNo = ''
      that.queryParam.mobileNo = ''
       that.queryParam.aadhaarName = ''
      that.queryParam.applyDate = undefined;
      that.queryParam.paymentDate = undefined;
      that.queryParam.endDate = undefined;
      that.queryParam.settleDate = undefined;
      that.loadData(this.form.pageNum)
    },
    changeModal (visible) {
        this.visible = visible;
    },
    handleDetail (row) {
        this.orderId = row.id;
        this.custInfoId = row.custInfoId;
        this.changeModal(true);
    },
    supplementaryRecording(record){
      const self = this;
      this.$confirm({

        title: 'Supplement Disbursement No.',
        content: h => {
          return <div>
            <div>
              Disbursement No.:<input id = 'payOutId' type = 'text' />
            </div>
          </div>
        },
        onOk() {
          self.loading = true;
          var payOutId = document.getElementById("payOutId").value;
          if(!payOutId.trim()){
            alert('DisbursementNo.cannot be empty');
            self.loadData();
            return false;
          }

          supplementaryRecording({ payoutErrorId: record.id, payOutId: payOutId}).then(res => {
            if(res.code===1000){
              self.loadData();
            }else{
              self.$message.error(res.msg);
              self.loadData();
            }

          }).catch(e => {
            self.loading = false;
            self.$message.error(e.message);
          })
        },
      });
    },


      // Repayment status sync
    loanFailedDeal(row){
       this.loading = true
         loanFailedDeal(Object.assign({}, {payoutErrorId : row.id})).then((res)=>{
              if(res.code===1000){
                this.loadData();
                  this.$message.success(res.msg)
              }else{
                  this.$message.error(res.msg);
                this.loadData();
              }
              this.loading = false
          }).catch(e => {
           self.loadData();
              this.$message.error(e.message);
           this.loading = false
          })
        // this.loadData(this.form.pageNum)
      },

    loanSuccessDeal(row){
      this.loading = true
      loanSuccessDeal(Object.assign({}, {payoutErrorId : row.id})).then((res)=>{
        if(res.code===1000){
          this.loadData();
          this.$message.success(res.msg)
        }else{
          this.$message.error(res.msg);
          this.loadData();
        }
        this.loading = false
      }).catch(e => {
        self.loadData();
        this.$message.error(e.message);
        this.loading = false
      })
      // this.loadData(this.form.pageNum)
    },
    cancelDeal(row){
      this.loading = true
      cancelDeal(Object.assign({}, {payoutErrorId : row.id})).then((res)=>{
        if(res.code===1000){
          this.loadData();
          this.$message.success(res.msg)
        }else{
          this.$message.error(res.msg);
          this.loadData();
        }
        this.loading = false
      }).catch(e => {
        self.loadData();
        this.$message.error(e.message);
        this.loading = false
      })
      // this.loadData(this.form.pageNum)
    },
    handleOk(e) {
      this.ModalText = '';
      this.visibleO = false;
    },
    jumpRepayUrl(row){
      paymentsLink(Object.assign({}, {orderId : row.id})).then((res)=>{
        if(res.code===1000){
            this.ModalText = res.data.url;
            this.visibleO = true;
        }else{
          this.$message.error(res.msg);
        }
      this.loading = false
    }).catch(e => {
        this.$message.error(e.message);
    })
    },
    reductionAmt (record) {
      const self = this;
      var lateFee = record.lateFee;
      var repayAmt = record.repayAmt;
      var applyAmt = record.applyAmt;
      var paymentAmt = record.paymentAmt;
      var deductionFee = record.deductionFee;
      this.$confirm({
        title: self.$t('order.isReductionAmt'),
        content: h => {
          return <div>
            <div>
              { self.$t('order.repaymentAmount')}:{repayAmt}
            </div>
            <div>
              {self.$t('order.applicationAmount')}:{applyAmt}
            </div>
            <div>
              {self.$t('order.loanAmount')}:{paymentAmt}
            </div>
            <div>
              { self.$t('order.forfeitPenalty')}:{lateFee}
            </div>
            <div>
              { self.$t('order.hadDeductionFee')}:{deductionFee}
            </div>
            <div>
              { self.$t('order.deductionFee')}:<input id = 'repayAmt'></input>
            </div>
            <div>
              { self.$t('order.deductionFeeEndDate')}:
              <select id = 'deductionFeeEndDate' style="margin-top: 3px;">
                <option value=''>No Limit</option>
                <option value='1'>1 Day</option>
                <option selected value='2'>2 Days</option>
              </select>
            </div>


          </div>
        },
        onOk() {
          self.loading = true;

          var repayAmt = document.getElementById("repayAmt").value;
          var deductionFeeEndDateOption = document.getElementById("deductionFeeEndDate").value;

          if(!repayAmt.trim()){
            alert('deduction fee should not null');

            self.loadData();

            return false;
          }

          if(repayAmt > record.repayAmt){
            alert('deduction fee lower than repay amount');
            return false;
          }

          reductionLateFee({ orderId: record.id, reductionAmt: repayAmt, deductionFeeEndDate: deductionFeeEndDateOption }).then(res => {
            if(res.code===1000){
              self.loadData();
              self.$message.success(res.msg)
            }else{
              self.$message.error(res.msg);
              self.loadData();
            }
          }).catch(e => {
            self.loading = false;
            self.$message.error(e.message);
          })
        },
      });
    },
    handleRepayAll (record) {

      const self = this;
      this.$confirm({

        title: self.$t('order.isSettle') + '(Full)',
        content: h => {
          return <div>
                <div>
                  Verify Password:<input id = 'password' type = 'password' />
                </div>
            </div>
        },
        onOk() {
          self.loading = true;
          var password = document.getElementById("password").value;

          if(!password.trim()){
            alert('Verification password cannot be empty');

            self.loadData();

            return false;
          }

          var md5Password = md5(password);

          repayOfflineAll({ orderId: record.id, password: md5Password}).then(res => {
            if(res.code===1000){
              self.loadData();
            }else{
              self.$message.error(res.msg);
              self.loadData();
            }

          }).catch(e => {
            self.loading = false;
            self.$message.error(e.message);
          })
        },
      });
    },
    extendOrder (record) {

      const self = this;
      this.$confirm({

        title: 'Confirm extension repayment online?',
        content: h => {
          return <div>
          <div>
          Verify Password:<input id = 'password' type = 'password' />
            </div>
            </div>
        },
        onOk() {
          self.loading = true;
          var password = document.getElementById("password").value;

          if(!password.trim()){
            alert('Verification password cannot be empty');

            self.loadData();

            return false;
          }

          var md5Password = md5(password);

          extendOffline({ orderId: record.id, password: md5Password}).then(res => {
            if(res.code===1000){
              self.loadData();
            }else{
              self.$message.error(res.msg);
              self.loadData();
            }

          }).catch(e => {
            self.loading = false;
            self.$message.error(e.message);
          })
        },
      });
    }

  }
}
</script>
<style lang="less" scoped>
 @import "~@/assets/less/common.less";
</style>
